module.exports = __webpack_public_path__ + "media/bootstrap-icons/blockquote-left-ea71851e.svg";